import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import styles from '../customStylesRadioButton';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import T from 'components/common/translations/Translate';

class FormInvoice extends Component {

  submitForm = (e) => {
    e.preventDefault();
    if (this.props.isInModal) {
      this.props.closeModal();
    } else {
      this.props.saveForm();
    }
  }

  handleChange = (name, value) => {
    this.props.handleChangeField(name, value);
  }

  render() {
    const { invoiceData, submitName = 'OK' } = this.props;
    return (
      <form
        className="no-marg"
        onSubmit={this.submitForm}
        style={{ padding: '10px' }}
      >
        <fieldset>
          <legend className="visuallyhidden">Invoice info Form</legend>

          <ul className="list-fields list-none">
            <li className="list-fields__item">
              <label htmlFor="company-name">
                <T>content.account.invoices.form.companyNameLabel</T>
              </label>
              <input
                onChange={(e) => this.handleChange("invoiceCompany", e.target.value)}
                value={invoiceData.invoiceCompany}
                type="text"
                id="company-name"
                name="_company-name"
              />
            </li>

            <li className="list-fields__item">
              <label htmlFor="address">
                <T>content.account.invoices.form.addressLabel</T>
              </label>
              <input
                onChange={(e) => this.handleChange("invoiceAddress", e.target.value)}
                value={invoiceData.invoiceAddress}
                type="text"
                id="address"
                name="_address"
              />
            </li>

            <li className="list-fields__item">
              <label htmlFor="tax-number">
                <T>content.account.invoices.form.taxNumberLabel</T>
              </label>
              <input
                onChange={(e) => this.handleChange("invoiceTaxNumber", e.target.value)}
                value={invoiceData.invoiceTaxNumber}
                type="tel"
                id="tax-number"
                name="_tax-number"
                maxLength={12}
              />
            </li>
          </ul>

          {this.props.isLogged &&
            <p className="agree mb-35">
              <label htmlFor="agreement" className="text-normal">
                <Checkbox
                  id="agreement"
                  checked={invoiceData.issueInvoiceEachBooking}
                  onChange={(e) => this.handleChange("issueInvoiceEachBooking", e.target.checked)}
                  classes={{
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  }}
                  className="checkbox-button"
                  name="agreement"
                />
                <T>content.account.invoices.form.checkboxInfo</T>
              </label>
            </p>
          }
          {this.props.isLoading
            ?
            <LoadingSpinner className="button button--expand" />
            :
            <button
              className="button button--expand"
              onClick={this.submitForm}
            >
              {submitName}
            </button>
          }
        </fieldset>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(FormInvoice));